<template>
  <input type="hidden" name="_token" v-model="_token" />
</template>

<script>
export default {
  name: "CsrfToken",
  computed: {
    _token() {
      return document.querySelector('meta[name="csrf-token"]').content;
    }
  }
};
</script>
